///**
// * Modified code derived from image-map.js (https://blog.travismclarke.com/project/imagemap/)
// * Copyright (c) 2020, Travis Clarke (https://www.travismclarke.com/)
// * This source code is licensed under the Apache-2.0 license
// */

///**
// * Image map coordinates can be generated using a utility from
// * https://www.image-map.net/
// */

/* eslint-disable-next-line */
var aptImageMap: any = aptImageMap || {};
aptImageMap = (function ($: JQueryStatic) {
	class ImageMap {
		selector: (any) | NodeListOf<Element>;
		constructor(selector: any, wait: number) {
			this.selector = selector instanceof Array ? selector : document.querySelectorAll(selector);
			if (document.readyState !== "complete") {
				window.addEventListener("load", this.update.bind(this));
			}
			else this.update();
			window.addEventListener("resize", this.debounce(this.update, wait).bind(this));
			window.addEventListener("resize", this.hideImg(this.update).bind(this));
		}

		static genAreaSelector(mapName: string) {
			return `map[name="${mapName}"] area`;
		}

		update() {
			const imgs: ImageMapNode[] = this.selector;
			let img: ImageMapNode;

			for (let i = 0; i < imgs.length; i++) {
				img = imgs[i];
				if (img.getAttribute("usemap") === undefined) return;
				const newImg = img.cloneNode();
				newImg.addEventListener("load", this.handleImageLoad(img.offsetWidth, img.offsetHeight));
			}
		}

		hideImg(func: Function) {
			return (...args: any) => {
				$(".btn-overlay img").fadeOut(0);
			};
		}

		debounce(func: Function, wait = 500) {
			let timeout: number;
			return (...args: any) => {
				window.clearTimeout(timeout);
				timeout = window.setTimeout((ctx: any) => func.apply(ctx, args), wait, this);
			};
		}

		handleImageLoad(offsetWidth: number, offsetHeight: number) {
			return (e: { target: { width: any; height: any; id: string; getAttribute: (arg0: string) => string } }) => {
				const w = e.target.width;
				const h = e.target.height;
				const mapName = e.target.getAttribute("usemap").replace(/^#/, "");
				const areas = document.querySelectorAll(ImageMap.genAreaSelector(mapName));
				const buttons = document.querySelectorAll(".btn-overlay");
				const id = $("#" + e.target.id);

				for (let i = 0; i < areas.length; i++) {
					const area: ImageMapArea = areas[i];
					const dataset = area.dataset;
					const button = buttons[i] as HTMLElement;
					const coordsString = dataset["coords"] = dataset["coords"] || area.getAttribute("coords");
					const coordsArrayOld = coordsString.split(",");
					const coordsArrayNew = coordsArrayOld.map(function (_: any, i: any) {
						// Scale the coordinate from the original width/height to the actual rendered width/height (i.e. offset)
						return i % 2 === 0 ? Number(coordsArrayOld[i] / w * offsetWidth) : Number(coordsArrayOld[i] / h * offsetHeight);
					});

					$(button).find("img").delay(500).fadeIn(100);
					const img = id.position();
					const imgOffsetTop = img.top;
					const imgOffsetLeft = img.left;

					button.style.top = coordsArrayNew[1] + imgOffsetTop + "px";
					button.style.left = coordsArrayNew[0] + imgOffsetLeft + "px";
					area.setAttribute("coords", coordsArrayNew.toString());
				}
			}
		}
	}

	function _ImageMap(selector: string, wait = 500) {
		_Setup();
		return new ImageMap(selector, wait);
	}

	function _Setup() {
		$(".btn-overlay, .area-overlay")
			.on("click", (el) => {
				aptUtils.showModalDialog("", $(el.currentTarget).data("message"));
			})
			.find("img").fadeOut(0);
	}

	return {
		imageMap: _ImageMap,
		init: () => { setTimeout(() => { _ImageMap('img[usemap]', 500); }, 500) }
	}

	interface ImageMapArea {
		dataset?: any;
		getAttribute: Function;
		setAttribute: Function;
	}

	interface ImageMapNode {
		getAttribute: Function;
		offsetHeight: 0;
		offsetWidth: 0;
		cloneNode: Function;
	}
}($));